if (!customElements.get('ovxs-header')) {
  class OvxsHeader extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-ovxs-header-bar]');
      this.overlay = this.querySelector('[data-ovxs-menu-overlay]');

      const toggle = this.querySelector('[data-ovxs-menu-toggle]');
      const close = this.querySelector('[data-ovxs-menu-close]');

      if (toggle) toggle.addEventListener('click', () => this.openMenu());
      if (close) close.addEventListener('click', () => this.closeMenu());
      this.querySelectorAll('[data-ovxs-menu-link]').forEach((link) => {
        link.addEventListener('click', () => this.closeMenu());
      });

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    openMenu() {
      if (!this.overlay) return;
      this.overlay.hidden = false;
      document.body.style.overflow = 'hidden';
    }

    closeMenu() {
      if (!this.overlay) return;
      this.overlay.hidden = true;
      document.body.style.overflow = '';
    }

    onScroll() {
      if (!this.bar) return;
      const scrolled = (window.scrollY || window.pageYOffset) > 36;
      this.bar.classList.toggle('ovxs-header--scrolled', scrolled);
    }
  }

  customElements.define('ovxs-header', OvxsHeader);
}
